import React, { useRef } from "react";
import { MeshDistortMaterial, useTexture } from "@react-three/drei";
import * as THREE from "three";
import { useStore } from "../store";
import { PresentationContext } from "./Board"
import { Presentation } from "../data/types";

type Props = JSX.IntrinsicElements["mesh"] & {
  prefix: string;
  size: number;
  xy: number[];
  radius: number;
  opacity?: number;
  offset?: { x: number; y: number };
  variant?: string;
};

export default function Blob({
  prefix,
  size,
  offset = { x: 0, y: 0 },
  xy = [0, 0],
  radius,
  opacity = 1,
  variant = "",
  ...props
}: Props) {
  const context = React.useContext(PresentationContext) as unknown
  const presentation = context as Presentation
  const pulseSpeedModifier = presentation.animationSpeed ? presentation.animationSpeed * .1 : .1
  const distortSpeed = useRef(Math.random() * pulseSpeedModifier);
  const selectedPersona = useStore((state) => state.selectedPersona)
  const [colorMap, alphaMap] = useTexture([
    `${process.env.PUBLIC_URL}/images/${prefix}-map.png`,
    `${process.env.PUBLIC_URL}/images/${prefix}-alpha.png`,
  ]);

  const position = new THREE.Vector3(
    xy[0] * radius + offset.x,
    xy[1] * radius - offset.y,
    size * 0.001
  );

  return (
    <mesh position={position} scale={size} {...props}>
      <planeGeometry args={[1, 1, 128, 128]} />
      {/*@ts-ignore*/}
      {!selectedPersona ? <MeshDistortMaterial
        map={colorMap}
        alphaMap={alphaMap}
        color={prefix.includes("yellow") ? "#f8f5e2" : undefined}
        distort={0.3}
        speed={distortSpeed.current}
        transparent
        opacity={opacity}
        depthWrite={false}
      />
        : (
          <meshBasicMaterial
            map={colorMap}
            alphaMap={alphaMap}
            color={prefix.includes("yellow") ? "#f8f5e2" : undefined}
            transparent
            opacity={opacity}
            depthWrite={false}
          />
        )}
    </mesh>
  );
}
